<div class="page  page--partner-dashboard" #pagePartnerDashboard>
  <div class="page__container">
    <h1 class="page__title h2">{{ 'partner_dashboard_title' | translate }}</h1>
    <div class="my-5">
      <p translate>partner_dashboard_intro</p>
    </div>
    <div class="row my-5">
      <div class="col-6 col-lg-4 mb-4">
        <wsb-ui-card title="{{ 'partner_dashboard_link_title' | translate }}" type="choice_card_a">
          <p class="py-2" [inlineSVG]="'assets/images/icons/icon-recipients.svg'"></p>
          <div class="mh-96" wsb-ui-card-footer>
            <span [innerHTML]="'partner_dashboard_link_descr' | translate"></span>
          </div>
        </wsb-ui-card>
      </div>
      <div class="col-6 col-lg-4 mb-4">
        <wsb-ui-card title="{{ 'partner_dashboard_affiliates_title' | translate }}" type="choice_card_a">
          <p class="py-2" [inlineSVG]="'assets/images/icons/icon-recipients.svg'"></p>
          <div wsb-ui-card-footer>
            <span [innerHTML]="'partner_dashboard_affiliates_descr' | translate"></span>
          </div>
        </wsb-ui-card>
      </div>
      <div class="col-6 col-lg-4 mb-4">
        <wsb-ui-card title="{{ 'partner_dashboard_earn_title' | translate }}" type="choice_card_a">
          <p class="py-2" [inlineSVG]="'assets/images/icons/icon-credits.svg'"></p>
          <div wsb-ui-card-footer>
            <span [innerHTML]="'partner_dashboard_earn_descr' | translate"></span>
          </div>
        </wsb-ui-card>
      </div>
    </div>
    <div *ngIf="referralBaseUrl">
      <div class="row my-3">
        <div class="col-12">
          <div class="card">
            <h5 class="card-header">{{ 'partner_dashboard_referrallink_pre' | translate }}</h5>
            <div class="card-body text-center card-body-neutral">
              <p><code [innerHTML]="referralBaseUrl"></code></p>
              <wsb-atlas-button class="mb-2 ms-3" [label]="'partner_dashboard_referrallink_btn'" routerLink="/partner/setup">{{
                'partner_dashboard_referrallink_btn' | translate
              }}</wsb-atlas-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
